import GitHub from "../images/active-contributors-on-github.svg";
import AWS from "../images/aws-certified.svg";
import UpWork from "../images/top-pluse-up-work.svg";
import shopifyPartners from '../images/shopify-partners.svg';

const EnterpriseSoftwareSolutions = [
  {
    id: 5,
    img: shopifyPartners,
    title: "Authorized  Shopify Partners",
    pathUrl: "https://www.shopify.com/partners/directory/partner/equest-solutions",
  },
  {
    id: 2,
    img: UpWork,
    title: "Top-Rated-PLUS provider of excellence",
    pathUrl: "https://www.upwork.com/ag/equestsolutions/",
  },
  // {
  //   id: 3,
  //   img: PWA,
  //   title: "Core contributors and PWA specialists",
  //   pathUrl: "",
  // },
  {
    id: 4,
    img: AWS,
    title: "AWS certified",
    pathUrl: "",
  },
  {
    id: 1,
    img: GitHub,
    title: "Active contributors on Github",
    pathUrl: "",
  },
];
export default EnterpriseSoftwareSolutions;
